/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "rotate-b79f277e--sprite",
  "use": "rotate-b79f277e--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"rotate-b79f277e--sprite\"><rect width=\"36\" height=\"36\" fill=\"#fff\" opacity=\"0\" /><path d=\"M625.9,4553.933l-2.25,2.26-.07.07a1.025,1.025,0,0,1-.71.29,1,1,0,0,1-.7-.29l-2.33-2.33a1,1,0,0,1,1.41-1.41l.52.52a5.54,5.54,0,1,0-5.44,6.59,1,1,0,0,1,0,2,7.54,7.54,0,1,1,7.48-8.44l.67-.67a1.008,1.008,0,0,1,1.42,0A1,1,0,0,1,625.9,4553.933Z\" transform=\"translate(-599.79 -4536.551)\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
